export const vueQueryConfig = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchIntervalInBackground: false, // Stop refetching when the tab is hidden
        refetchOnWindowFocus: false, // Stop refetching when user switches back to the browser tab
        refetchOnReconnect: false, // Stop refetching when the network reconnects
        refetchOnMount: false,
        retry: false, // Disable automatic retries to avoid repeated failed requests in case of an error
        staleTime: Infinity, // Treat the data as "fresh" for a long time so it doesn't re-verify constantly
      },
    },
  },
};
